import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { BmsjHipsterSharedModule, RouteAccessService } from './shared';
import { BmsjHipsterAppRoutingModule } from './app-routing.module';
import { BmsjHipsterEntityModule } from './entities/entity.module';
import { ErrorComponent, JhiMainComponent, PageRibbonComponent } from './layouts';
import { LabelPrintingModule } from './label-printing/label-printing.module';
import { DesignCrossesModule } from './design-crosses/design-crosses.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GermplasmManagerModule } from './germplasm-manager/germplasm-manager.module';
import { AuthExpiredInterceptor } from './blocks/interceptor/auth-expired.interceptor';
import { InventoryDetailsModule } from './germplasm-manager/inventory/details/inventory-details.module';
import { NavbarModule } from './navbar/navbar.module';
import { GermplasmDetailsModule } from './germplasm-details/germplasm-details.module';
import { ReleaseNotesModule } from './release-notes/release-notes.module';
import { UserProfileModule } from './entities/user-profile/user-profile.module';
import { FileManagerModule } from './file-manager/file-manager.module';
import { VariableDetailsModule } from './ontology/variable-details/variable-details.module';
import { CropSettingsManagerModule } from './crop-settings-manager/crop-settings-manager.module';
import { GermplasmListModule } from './germplasm-list/germplasm-list.module';
import { CopModule } from './cop/cop.module';
import { AboutModule } from './about/about.module';
import { ProgramSettingsManagerModule } from './program-settings-manager/program-settings-manager.module';
import { CreateProgramModule } from './entities/create-program/create-program.module';
import { StudyManagerModule } from './study-manager/study-manager.module';
import { SiteAdminModule } from './site-admin/site-admin.module';
import { ObservationDetailsModule } from './entities/observation/observation-details.module';
import { LoginModule } from './shared/login/login.module';
import { HighDensityModule } from './high-density/high-density.module';
import { FieldManagementModule } from './field-management/field-management.module';
import { SingleSiteAnalysisModule } from './single-site-analysis/single-site-analysis.module';
import { MultiSiteAnalysisModule } from './multi-site-analysis/multi-site-analysis.module';
import { TimeOutService } from './shared/interceptor/service/time-out.service';
import { StudyEditorModule } from './study-editor/study-editor.module';
import { LoadingIndicatorComponent, LoadingInterceptor } from './shared/loading-indicator';
import { FieldMapModule } from './study-manager/field-map/field-map.module';
import { LotDetailModule } from './entities/lot-detail/lot-detail.module';
import { InventoryManagerLotModule } from './entities/lot/lot.module';
import { InventoryManagerTransactionModule } from './entities/transaction/transaction.module';
import { MultiTraitQueryModule } from './multi-trait-query/multi-trait-query.module';
import { HeadToHeadQueryModule } from './head-to-head-query/head-to-head-query.module';
import { ErrorInterceptor } from './blocks/interceptor/error.interceptor';
import { InventoryManagerModule } from './inventory-manager/inventory-manager.module';
import { BrapiSyncModule } from './brapi-sync/brapi-sync.module';
import { OntologyManagerModule } from './ontology-manager/ontology-manager.module';

// Factory function that returns a Promise
// When this app is initializing, make sure to initialize the timeoutService
// to get the timeout configuration from the server.
export function initializeTimeoutService(timeoutService: TimeOutService) {
    return () => timeoutService.initialize();
}


@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        BmsjHipsterAppRoutingModule,
        NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-' }),
        BmsjHipsterSharedModule,
        BmsjHipsterEntityModule,
        NavbarModule,
        LabelPrintingModule,
        DesignCrossesModule,
        GermplasmManagerModule,
        InventoryDetailsModule,
        GermplasmDetailsModule,
        ObservationDetailsModule,
        ReleaseNotesModule,
        UserProfileModule,
        FileManagerModule,
        CopModule,
        CropSettingsManagerModule,
        VariableDetailsModule,
        GermplasmListModule,
        ProgramSettingsManagerModule,
        AboutModule,
        CreateProgramModule,
        StudyManagerModule,
        SiteAdminModule,
        HighDensityModule,
        LoginModule,
        FieldManagementModule,
        SingleSiteAnalysisModule,
        MultiSiteAnalysisModule,
        StudyEditorModule,
        LoadingIndicatorComponent,
        LotDetailModule,
        InventoryManagerModule,
        InventoryManagerLotModule,
        InventoryManagerTransactionModule,
        FieldMapModule,
        MultiTraitQueryModule,
        HeadToHeadQueryModule,
        BrapiSyncModule,
        HeadToHeadQueryModule,
        OntologyManagerModule
        // jhipster-needle-angular-add-module JHipster will add new module here
    ],
    declarations: [
        JhiMainComponent,
        PageRibbonComponent,
        ErrorComponent
    ],
    providers: [
        RouteAccessService,
        TimeOutService,
        {
            // When this app is initializing, make sure to initialize the timeoutService
            // to get the timeout configuration from the server.
            provide: APP_INITIALIZER,
            useFactory: initializeTimeoutService,
            deps: [TimeOutService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthExpiredInterceptor,
            multi: true,
            deps: [
                Injector
            ]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
            deps: [
                Injector
            ]
        },
    ],
    bootstrap: [JhiMainComponent]
})
export class BmsjHipsterAppModule {
}

